import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingBagIcon, MenuIcon } from 'lucide-react';
const Header = () => {
  return <header className="bg-white border-b border-gray-200 py-4 px-6" data-id="element-130">
      <div className="max-w-7xl mx-auto flex items-center justify-between" data-id="element-131">
        <div className="flex items-center" data-id="element-132">
          <ShoppingBagIcon className="h-8 w-8 text-blue-600" data-id="element-133" />
          <span className="ml-2 text-xl font-bold text-gray-800" data-id="element-134">
            Multichannel Listings
          </span>
        </div>
        <div className="flex items-center space-x-4" data-id="element-135">
          <Link to="/" className="text-gray-600 hover:text-blue-600" data-id="element-136">
            Dashboard
          </Link>
          <Link to="#" className="text-gray-600 hover:text-blue-600" data-id="element-137">
            Settings
          </Link>
          <button className="p-2 rounded-full hover:bg-gray-100" data-id="element-138">
            <MenuIcon className="h-5 w-5 text-gray-600" data-id="element-139" />
          </button>
        </div>
      </div>
    </header>;
};
export default Header;